import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_REMOVE_ENV_CONSTANT_BEGIN,
  APP_SETTING_REMOVE_ENV_CONSTANT_SUCCESS,
  APP_SETTING_REMOVE_ENV_CONSTANT_FAILURE,
  APP_SETTING_REMOVE_ENV_CONSTANT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function removeEnvConstant(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_REMOVE_ENV_CONSTANT_BEGIN,
    });

    const { projectId, envId, uuid, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const URL = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/environments/${envId}/constants/${uuid}`;
      const doRequest = axios.delete(URL, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_REMOVE_ENV_CONSTANT_SUCCESS,
              data: res.data,
            });
            toast.success('Removed Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_REMOVE_ENV_CONSTANT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_REMOVE_ENV_CONSTANT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissRemoveEnvConstantError() {
  return {
    type: APP_SETTING_REMOVE_ENV_CONSTANT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_REMOVE_ENV_CONSTANT_BEGIN:
      return {
        ...state,
        removeEnvConstantPending: true,
        removeEnvConstantError: null,
      };

    case APP_SETTING_REMOVE_ENV_CONSTANT_SUCCESS:
      return {
        ...state,
        removeEnvConstantPending: false,
        removeEnvConstantError: null,
      };

    case APP_SETTING_REMOVE_ENV_CONSTANT_FAILURE:
      return {
        ...state,
        removeEnvConstantPending: false,
        removeEnvConstantError: action.data.error,
      };

    case APP_SETTING_REMOVE_ENV_CONSTANT_DISMISS_ERROR:
      return {
        ...state,
        removeEnvConstantError: null,
      };

    default:
      return state;
  }
}
